exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".lt-1 {\n    fill: #fbe57f;\n  }\n\n.lt-2 {\n    fill: #001927;\n  }\n", ""]);
